import { createContext } from "react";

export const LoginContext = createContext({
  /** Unpaid grace period or payment_setting.read_only (e.g. participant limit). */
  isUserGracePeriodOver: false,
  scrollToTop: () => {},
});
